import React from 'preact/compat';
import { h } from 'preact';
import { List } from 'apis/list/graphqlTypes';
import { PREFIX } from 'list/DesignSystem/constants';
import { FavouritesPayload } from 'helpers/pubsub';
import translate from 'list/utils/translate';
import './lists.scss';

type ListProps = {
    addToList: (payload: FavouritesPayload, listId: string, name: string) => Promise<void>;
    lists: List[];
    payload: FavouritesPayload;
};

const Lists = ({ addToList, lists, payload }: ListProps) => {
    return (
        <ul className={`${PREFIX}lists`}>
            {lists.map(({ listId, retail: { items }, name, quantity }) => {
                const image =
                    items[items.length - 1]?.product?.images?.find(({ quality }) => quality === 'S3')?.url ?? ' ';
                return (
                    <button className="list" onClick={() => addToList(payload, listId, name)} key={listId}>
                        <img className="list-image" src={image} alt="" />
                        <div>
                            <div className="list-name">{name || translate('Default list name')}</div>
                            <div className="list-items">
                                {translate('x items', {
                                    quantity: String(quantity),
                                })}
                            </div>
                        </div>
                    </button>
                );
            })}
        </ul>
    );
};

export default Lists;
